{
  "hero": {
    "liveBadge": "{{count}} 個競賽公開中",
    "title": "認識 NAPAICP 競賽平台",
    "description": "從報名組隊、作品繳交，到評審打分與結果公布，NAPAICP 提供一站式的競賽管理體驗，並支援研討會等活動的接駁車預約、現場驗票與餐飲回覆。這裡先讓你快速了解平台在做什麼；想知道每個角色實際怎麼操作，可以直接前往詳細操作說明。",
    "primaryCta": "立即登入",
    "secondaryCta": "快速開始"
  },
  "quickNav": {
    "label": "頁內導覽",
    "features": "系統特色",
    "roles": "角色總覽",
    "notices": "使用須知",
    "team": "平台開發團隊"
  },
  "features": {
    "heading": "系統特色",
    "multiCompetition": {
      "title": "多場競賽同時進行",
      "description": "每場競賽的隊伍、作品與權限彼此獨立，不會互相干擾，一個平台可以同時辦好幾場比賽。"
    },
    "dynamicForms": {
      "title": "報名與繳交表單可自訂",
      "description": "每場競賽可以依需求設計自己的報名與作品繳交表單欄位，發布後仍保留歷史版本紀錄。"
    },
    "rubricJudging": {
      "title": "標準化評分流程",
      "description": "評審依主辦方設定好的評分表逐項打分，指派清楚、流程一致，也支援評審迴避利益衝突。"
    },
    "resultsAudit": {
      "title": "結果透明可追溯",
      "description": "成績計算、鎖定與公布都會留下紀錄，任何調整都看得到是誰、在什麼時候、為什麼調整。"
    },
    "events": {
      "title": "活動現場服務",
      "description": "除了競賽，也支援研討會等活動的免費接駁車預約與 QR 驗票、餐飲與宴會回覆、公告與客服；報名與付款仍以官方報名系統為準。",
      "cta": "了解活動平台"
    }
  },
  "roles": {
    "heading": "三種角色，各自的入口",
    "description": "平台依身分提供不同的操作介面；點選任一角色可以看到該角色的詳細操作步驟。",
    "student": {
      "title": "學生",
      "description": "報名參賽、組建隊伍、填寫表單、上傳並繳交作品，隨時查看評分與結果。"
    },
    "judge": {
      "title": "評審",
      "description": "查看被指派的作品（僅顯示匿名代碼），依評分表逐項評分並送出。"
    },
    "admin": {
      "title": "主辦方",
      "description": "建立競賽、設計表單與組別、指派評審，並在評選完成後公布結果。"
    },
    "viewSteps": "查看操作步驟"
  },
  "notices": {
    "heading": "使用須知",
    "account": "登入方式依平台目前開放狀況而定：目前支援信箱密碼註冊登入；若登入頁顯示「使用 Google 帳號登入」按鈕，也可以直接用 Google 帳號登入。",
    "schedule": "各競賽的報名、繳交與評審時程以該競賽頁面公告為準，平台首頁僅顯示目前公開中的競賽。",
    "dataHandling": "作品檔案私密上傳，僅透過短效簽名網址存取；評審打分過程中看不到隊伍與學生的真實身分。",
    "support": "操作上有疑問，可先參考詳細操作說明；仍無法解決時請聯絡競賽主辦方。",
    "events": "活動頁（主導覽「活動」）與競賽獨立：接駁車可只用 Email 預約，現場以乘車 QR 驗票；乘車與餐飲資料於活動結束後 30 天自動刪除。"
  },
  "team": {
    "visitSite": "前往 {{name}} 網站",
    "orgs": {
      "napai": {
        "name": "教育部前瞻AI人培－智慧代理及實體AI課程推動計畫 (NAPAI)"
      },
      "ai4x": {
        "name": "國立臺北大學跨域人工智慧前瞻研究中心 (NTPU AI4X)"
      },
      "moe-ite": {
        "name": "教育部資訊及科技教育司"
      },
      "ncu": {
        "name": "國立中央大學"
      },
      "ntpu": {
        "name": "國立臺北大學"
      },
      "nthu": {
        "name": "國立清華大學"
      }
    }
  },
  "cta": {
    "heading": "準備好了嗎？",
    "description": "登入後即可依你的角色開始使用平台。",
    "architectureCta": "技術架構"
  }
}
